<template>
  <div class="global-rating-inline" :class="classModifier">
    <div class="card-rating card-rating--normalize">
      <div class="rating--uniform timeline-review">
        <div class="rate-star--uniform" :class="`rate-star--uniform-${starFillNumber}`">
          <component
            :is="isUseLocalImage ? 'div' : 'span'"
            v-for="i in totalStars"
            :key="i"
            :class="{
              [`rated-${partialRatingValue}`]: isUseLocalImage && isPartialRated(i),
              'rated-10': isUseLocalImage && i <= avgRating,
            }"
          />
        </div>
        <span v-if="!isNaN(averageRating) && averageRating" class="card-average-rating">{{
          parseFloat(averageRating).toFixed(1)
        }}</span>
        <span v-else class="card-average-rating">0.0</span>
        <small v-if="inlineReviewers && isInlineReviewCount">
          ({{ $options.filters.cnvrtNumberToK(inlineReviewers) }})
        </small>
        <small v-if="inlineReviewers && !isInlineReviewCount"
          >({{ $options.filters.cnvrtNumberToK(inlineReviewers) }})
        </small>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
/* eslint-disable vue/require-prop-types */
export default {
  name: 'rating-inline',
  props: {
    isInlineReviewCount: {
      type: Boolean,
      required: false,
      default: false,
    },

    inlineReviewers: {
      required: false,
    },
    averageRating: {
      type: [String, Number],
      required: false,
    },
    classModifier: {
      type: String,
      required: false,
      default: '',
    },
    starFillNumber: {
      type: [String, Number],
      required: true,
    },
    totalStars: {
      type: Number,
      default: 5,
    },
    isUseLocalImage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    avgRating() {
      return Number(this.averageRating);
    },
    partialRatingValue() {
      const str = this.avgRating.toString();
      return str.charAt(str.length - 1);
    },
  },
  methods: {
    isPartialRated(i) {
      const left = i - this.avgRating;
      return left > 0 && left < 1;
    },
  },
};
</script>

<style lang="scss">
.card-rating--normalize {
  background: transparent;
}

.card-average-rating {
  // font: 12px/15px "lato-bold";
  // line-height: 12px;
  line-height: 15px;
  font-family: 'Lato-bold';
  font-size: 12px;
  font-weight: normal;
}

.card-rating {
  .rating--uniform {
    &.timeline-review {
      .rate-star--uniform {
        width: auto;
        margin-right: 4px;
        span {
          &:before {
            background-color: transparent;
          }
        }
      }
    }
  }
}

.rating--uniform {
  &.timeline-review {
    justify-content: center;
    // margin-bottom: 9px;
  }
}
small {
  color: #9b9b9b;
  font-size: 12px;
  margin: -1px 0 0 4px;
  line-height: 16px;
}
</style>
